import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMemberStatusNewFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.0002 2.08301C14.3652 2.08301 17.9168 5.63384 17.9168 9.99967C17.9168 14.3647 14.3652 17.9163 10.0002 17.9163C5.63516 17.9163 2.0835 14.3647 2.0835 9.99967C2.0835 5.63384 5.63516 2.08301 10.0002 2.08301ZM9.99528 6.86247C9.65026 6.86264 9.37028 7.14239 9.37028 7.48747V9.37549L7.6613 8.76921C7.33595 8.65387 6.97829 8.82473 6.86296 9.15006C6.74786 9.47531 6.91858 9.8323 7.24381 9.94759L8.96338 10.5571L7.73291 12.1131C7.51907 12.3839 7.56561 12.7772 7.83626 12.9912C8.10689 13.2048 8.4995 13.159 8.71354 12.8887L9.99528 11.2676L11.2868 12.9001C11.5008 13.1707 11.8941 13.2173 12.1649 13.0034C12.4356 12.7893 12.4815 12.3961 12.2674 12.1253L11.0272 10.5563L12.7581 9.94271C13.0832 9.82728 13.2533 9.47044 13.1382 9.14518C13.0229 8.81999 12.666 8.64938 12.3407 8.76432L10.6203 9.37386V7.48747C10.6203 7.14228 10.3404 6.86247 9.99528 6.86247Z"
	})
});
export default SvgMemberStatusNewFill;
